import React, { useEffect, useState } from "react";
import { LandingHeaderContainer, LandingHeaderWrapper, NavbarItem } from "./layout.styles";
import Container from "../Container";
import { useHistory } from "react-router-dom";

// import logoImg from "../../assets/image/logoN.png";
import Button from "../Button/Button";
import { SidebarClose } from "../AppLayout/applayout.styles";
import Sidebar from "../AppLayout/Sidebar";

const LandingHeader: React.FC = () => {
    const [sidebar, setSidebar] = useState(false);
    const router = useHistory();
    const handleScroll = () => {
        const header: any = document.querySelector("#landing-header");
        if (document.documentElement.scrollTop > 0) {
            header.style.boxShadow = "0 1rem 3rem rgb(31 45 61 / 13%)";
        } else {
            header.style.boxShadow = "none";
        }
    };
    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => {
            document.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <>
            <LandingHeaderWrapper id="landing-header">
                <Container>
                    <LandingHeaderContainer>

                        <NavbarItem to="">Buy SVC</NavbarItem>
                        <Button
                            label="Enter APP"
                            onClick={() => {
                                router.push("/app");
                            }}
                        />
                    </LandingHeaderContainer>
                </Container>
            </LandingHeaderWrapper>
            <Sidebar active={sidebar} onClick={() => setSidebar(false)}>
                <SidebarClose onClick={() => setSidebar(false)}>
                    <i className="bi bi-x-lg"></i>
                </SidebarClose>
                <NavbarItem to="">Buy SVC</NavbarItem>
            </Sidebar>
        </>
    );
};

export default LandingHeader;
